/**
 * Set date language in short format, example: Sept, 19
 */
export function setDateLangShortFormat(date: string, lang: string): string {
  const dateLang = lang === 'es' ? 'es-ES' : 'en-EN';

  const dateFormatter = new Intl.DateTimeFormat(dateLang, {
    day: '2-digit',
    month: 'short',
    timeZone: 'America/New_York',
  })
    .formatToParts(new Date(`${date}T00:00:00`))
    .filter(format => format.type === 'month' || format.type === 'day')
    .sort((a, b) => a.type.localeCompare(b.type));

  return `${dateFormatter[1].value}, ${dateFormatter[0].value}`;
}
